import React, { useEffect, useState } from "react";
import Modal from "../../components/modal";
import { XIcon, FileSpreadsheetIcon } from "lucide-react";
import apiClient from "../../utils/apiClient";
import server from "../../utils/serverConfig";

const alphaMapping = {
  "Alpha 50": "Alpha_nifty_50",
  "Alpha 100": "Alpha_nifty_100",
  "Alpha 200": "Alpha_nifty_200",
  "Alpha 500": "Alpha_nifty_500",
  "Alpha SNP": "Alpha_snp_500",
  // "Alpha NDX": "Alpha_nasdaq_100",
};

const WTDTable = ({
  selectedIndex,
  data,
  filteredWTDs,
  year,
  month,
  onBack,
  onMTDClick,
  selectedStrategy,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedWeekStocks, setSelectedWeekStocks] = useState([]);
  const [indexColorCodeData, setIndexColorCodeData] = useState([]);
  const [allWeekStocks, setAllWeekStocks] = useState({});

  // const getWeeklySelections = (var_name, alpha_name, date) => {
  //   setIsLoading(true);

  //   const data = {
  //     var_name: var_name,
  //     alpha_name: alpha_name,
  //     date: date,
  //   };
  //   let config = {
  //     method: "POST",
  //     url: `https://godseye.server.sypto.xyz/get-weekly-selection`,
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: JSON.stringify(data),
  //   };

  //   axios
  //     .request(config)
  //     .then((response) => {
  //       console.log("Weekly selections response:", response.data);
  //       setSelectedWeekStocks(response.data);
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //       setIsLoading(false);
  //     });
  // };

  
  useEffect(() => {
    const fetchAllWeekStocks = async () => {
      setIsLoading(true);
      if (!filteredWTDs?.length) return;

      const indexName = alphaMapping[selectedIndex] || selectedIndex;
      const weekDates = [];

      filteredWTDs.forEach((item) => {
        const mtds = item?.ytds[0]?.mtds;
        const matchedMonth = mtds.find((m) => m.month === month);
        const wtds = matchedMonth?.wtds || [];
        wtds.forEach((week) => {
          if (!weekDates.includes(week.week_date)) {
            weekDates.push(week.week_date);
          }
        });
      });

      const results = {};

      for (const date of weekDates) {
        try {
          const res = await apiClient.post(
            `${server.godseye.baseUrl}get-weekly-selection`,
            {
              var_name: data.strategy,
              alpha_name: indexName,
              date: date,
            }
          );

          results[date] = res.data;
        } catch (err) {
          console.error("Failed to fetch for date:", date);
          results[date] = [];
          setIsLoading(false);
        }
      }

      setAllWeekStocks(results);
      setIsLoading(false);
    };

    fetchAllWeekStocks();
  }, [filteredWTDs, selectedIndex, month]);

  return (
    <div>
      <div className="flex items-center space-x-10">
        <button
          onClick={onBack}
          className="mb-4 py-1 text-xs font-medium px-4 bg-gray-300 text-black rounded"
        >
          Back
        </button>
        <h2 className="text-lg font-bold mb-4">
          WTD Values for Strategy --- {data.strategy} , Month --- {month} , Year
          --- {year}
        </h2>
      </div>
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="">
          <tr>
            <th className="border border-gray-300 px-2 py-[1px] text-sm text-left font-medium text-gray-100 uppercase tracking-wider">
              Week
            </th>
            {filteredWTDs[0]?.ytds[0]?.mtds
              ?.find((m) => m.month === month)
              ?.wtds?.map((week, idx) => (
                <th
                  key={week + idx}
                  className="relative border font-semibold border-gray-300 px-2 py-[1px] text-sm text-gray-100 uppercase tracking-wider"
                >
                  <div className="relative z-10 flex items-center justify-center">
                    <span>{`W${idx + 1} -- (${week?.regime}) `}</span>
                  </div>
                </th>
              ))}
          </tr>
        </thead>
        <tbody className="">
          {filteredWTDs?.map((item, idx) => {
            // console.log(`item at index ${idx}`, item);

            const mtds = item?.ytds[0]?.mtds;
            // const wtds = mtds?.[mtds.length - 1]?.wtds;
            const matchedMonth = mtds.find((item) => item.month === month);
            const wtds = matchedMonth?.wtds || [];
            // console.log(`WTDS at index ${idx}`, wtds);

            return (
              <tr
                key={idx}
                onClick={() => onMTDClick(year,month,idx)}
                className={`cursor-pointer ${
                  idx === selectedStrategy
                    ? " text-gray-100 bg-amber-700 "
                    : "text-gray-100"
                }`}
              >
                <td
                  className={`cursor-pointer relative border border-gray-300 px-2 py-[1px] `}
                >
                  <div className="relative  z-20 text-white">
                    {item.strategy}
                  </div>
                </td>
                {wtds?.map((week, wdx) => (
                  <td
                    key={week?.week_data + wdx}
                    className="relative border border-gray-300 px-2 py-[1px] text-right  cursor-pointer"
                  >
                    {week?.bgColor && item?.strategy !== "Custom strategy" && (
                      <div
                        style={{
                          backgroundColor: week?.bgColor,
                        }}
                        className="z-0 absolute inset-0  pointer-events-none"
                      ></div>
                    )}
                    <div className="relative z-10 font-semibold flex w-full items-center  justify-end ">
                      {week?.week_data}
                      {/* {item?.strategy !== "Custom strategy" && (
                        <FileSpreadsheetIcon
                        onClick={() =>
                          handleOpenModal(
                            item?.strategy,
                            selectedIndex,
                            week?.week_date
                          )
                        }
                        className="text-white h-4 w-4 ml-5"
                      />
                      )} */}
                    </div>
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>

      <div className="mt-8 text-white px-5">
        <h3 className="text-lg font-bold mb-4">Weekly Selected Stocks for strategy - 
           <span className="ml-2 text-amber-500">{data?.strategy}</span>
          </h3>

        {isLoading && (
          <div className="flex text-[16px] font-medium w-full">
            Loading weekly stocks data ....
          </div>
        )}

        {!isLoading && (
          <div className="flex  gap-x-4 ">
            {Object.entries(allWeekStocks).map(([date, stocks], idx) => (
              <div key={date} className="mb-8">
                <h4 className="font-semibold text-amber-400 mb-2">{`WEEK-${
                  idx + 1
                } (${date})`}</h4>

                {stocks.length === 0 ? (
                  <p className="text-gray-400">No stock data available.</p>
                ) : (
                  <table className="w-full min-w-[220px] border border-gray-700 text-left text-sm">
                    <thead className="bg-gray-800 text-gray-300">
                      <tr>
                        <th className="border border-gray-600 px-3 py-2">
                          Symbol
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {stocks.map((stock, sIdx) => (
                        <tr
                          title={stock.companyName}
                          key={sIdx}
                          className="bg-gray-900 hover:bg-gray-800"
                        >
                          <td className="border border-gray-700 px-3 py-1 font-semibold">
                            {stock.symbol}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default WTDTable;
